import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
import { SalesLensCategoryResponseModel } from '@/types/clarityLens'

export const getSalesLensCategories = async (
  branchName: string,
  startDate: string,
  endDate: string
): Promise<SalesLensCategoryResponseModel[]> => {
  try {
    const response = await axios.get(
      `${BASE_URL}/daily-sales-lens/sub-sub-categories`,
      {
        params: {
          start_date: startDate,
          end_date: endDate,
          branch_names: branchName,
          limit: 1000,
        },
      }
    )

    return response.data
  } catch (error) {
    throw error
  }
}
